<template>
  <div class="page-container" id="page-container">
    <div class="page-title padding pb-0 ">
      <h2 class="text-md mb-0">{{ $t('message.Lawyer.title') }}</h2>
    </div>
    <div class="padding">
      <div class="row">
        <div class="col-md-12">
          <div v-if="!lawyersLoaded" class="h-100 d-flex justify-content-center align-items-center">
            <img alt="Vue logo" src="@/assets/img/loading.gif" width="100px" height="100px">
          </div>

          <div v-else class="card card-form">
            <div class="card-body">
              <div class="form-section-header">Neuer {{ $t('message.Lawyer.title') }}</div>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">Name <var class="text-danger">*</var></label>
                </b-col>

                <b-col sm="9">
                  <b-form-input
                      :class="errors.first('lawyer.name')?'is-invalid':''"
                      v-model="lawyer.name"
                      v-validate="'required'"
                      data-vv-name="name"
                      type="text"
                      placeholder="name"
                      ref="nameField"
                      :state="errors.first('name') ? false : null">
                  ></b-form-input>
                  <div v-if="errors.first('name')" class="text-danger">Bitte einen Wert eingeben.</div>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">Email <var class="text-danger">*</var></label>
                </b-col>

                <b-col sm="9">
                  <b-form-input
                      :class="errors.first('lawyer.email')?'is-invalid':''"
                      v-model="lawyer.email"
                      v-validate="'required|email'"
                      data-vv-name="email"
                      type="text"
                      placeholder="email"
                      ref="nameField"
                      :state="errors.first('email') ? false : null">
                  ></b-form-input>
                  <div v-if="errors.first('email')" class="text-danger">Bitte einen Wert eingeben.</div>
                </b-col>
              </b-row>


              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">Contact email <var class="text-danger">*</var></label>
                </b-col>

                <b-col sm="9">
                  <b-form-input
                      :class="errors.first('lawyer.email_contact')?'is-invalid':''"
                      v-model="lawyer.email_contact"
                      v-validate="'required|email'"
                      data-vv-name="email_contact"
                      type="text"
                      placeholder="contact email"
                      ref="nameField"
                      :state="errors.first('email_contact') ? false : null">
                  ></b-form-input>
                  <div v-if="errors.first('email_contact')" class="text-danger">Bitte einen Wert eingeben.</div>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">Url <var class="text-danger">*</var></label>
                </b-col>

                <b-col sm="9">
                  <b-form-input
                      :class="errors.first('lawyer.url')?'is-invalid':''"
                      v-model="lawyer.url"
                      v-validate="'required|force-http-prefix'"
                      data-vv-name="url"
                      type="text"
                      placeholder="url"
                      ref="nameField"
                      :state="errors.first('url') ? false : null">
                  ></b-form-input>

                  <p class="text-danger" v-if="errors.firstByRule('url', 'force-http-prefix')"> {{ errors.firstByRule('url', 'force-http-prefix') }} </p>
                  <template v-else><p class="text-danger" v-if="errors.has('url')">Url bitte eingeben.</p></template>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">Url label<var class="text-danger">*</var></label>
                </b-col>

                <b-col sm="9">
                  <b-form-input
                      :class="errors.first('lawyer.url_label')?'is-invalid':''"
                      v-model="lawyer.url_label"
                      v-validate="'required'"
                      data-vv-name="url_label"
                      type="text"
                      placeholder="url_label"
                      ref="nameField"
                      :state="errors.first('url_label') ? false : null">
                  ></b-form-input>
                  <div v-if="errors.first('url_label')" class="text-danger">Bitte einen Wert eingeben.</div>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">web<var class="text-danger">*</var></label>
                </b-col>

                <b-col sm="9">
                  <b-form-input
                      :class="errors.first('lawyer.web')?'is-invalid':''"
                      v-model="lawyer.web"
                      v-validate="'required'"
                      data-vv-name="web"
                      type="text"
                      placeholder="web"
                      ref="nameField"
                      :state="errors.first('web') ? false : null">
                  ></b-form-input>
                  <div v-if="errors.first('web')" class="text-danger">Bitte einen Wert eingeben.</div>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">address<var class="text-danger">*</var></label>
                </b-col>

                <b-col sm="9">
                  <b-form-input
                      :class="errors.first('lawyer.address')?'is-invalid':''"
                      v-model="lawyer.address"
                      v-validate="'required'"
                      data-vv-name="address"
                      type="text"
                      placeholder="address"
                      ref="nameField"
                      :state="errors.first('address') ? false : null">
                  ></b-form-input>
                  <div v-if="errors.first('address')" class="text-danger">Bitte einen Wert eingeben.</div>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">Phone <var class="text-danger">*</var></label>
                </b-col>

                <b-col sm="9">
                  <b-form-input
                      :class="errors.first('lawyer.phone')?'is-invalid':''"
                      v-model="lawyer.phone"
                      v-validate="'required'"
                      data-vv-name="phone"
                      type="text"
                      placeholder="phone"
                      ref="nameField"
                      :state="errors.first('phone') ? false : null">
                  ></b-form-input>
                  <div v-if="errors.first('phone')" class="text-danger">Bitte einen Wert eingeben.</div>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">Photo</label>
                </b-col>

                <b-col sm="9">
                  <b-img v-if="lawyer.photo && lawyer.photo.url" thumbnail fluid :src="lawyer.photo.url" />
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Lawyer.categories') }} <var class="text-danger">*</var></label>
                </b-col>

                <b-col sm="9">
                  <multiselect
                    id="categories"
                    name="categories"
                    v-model="lawyer.categories"
                    data-vv-name="lawyer.categories"
                    data-vv-model="lawyer.categories"
                    :options="categoriesOptions"
                    :searchable="true"
                    deselect-label=""
                    select-label=""
                    selected-label=""
                    :multiple="true"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :placeholder="$t('message.Lawyer.categories')"
                    :preselect-first="false"
                    v-validate="'required'"
                    track-by="id"
                    label="name">
                  </multiselect>
                  <div v-if="errors.first('lawyer.categories')" class="text-danger">{{ $t('message.Lawyer.errors.categories') }}</div>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Lawyer.default') }}</label>
                </b-col>

                <b-col sm="9">
                  <b-form-checkbox
                    id="default"
                    v-model="lawyer.default"
                    name="default"
                    value="true"
                    unchecked-value="false"/>
                </b-col>
              </b-row>

              <div class="form-section-header">{{ $t('message.Lawyer.sectionFileUploader') }}</div>
              <div class="dropzone mb-4" v-show="$refs.upload && $refs.upload.drop">
                <div :class="{ 'dragActive' : $refs.upload && $refs.upload.dropActive }">
                  <h5 v-html="$t('message.Lawyer.dragAndDrop')"></h5>
                  <label for="file" class="btn btn-primary">{{ $t('message.Lawyer.selectFiles') }}</label>
                </div>
              </div>

              <file-upload
                ref="upload"
                v-model="uploadedFiles"
                name="file"
                :drop="true"
                @input-filter="inputFilter"
                @input="upload"
                :multiple="false"
                :rerender="rerender">
              </file-upload>

              <template v-if="lawyer.files && lawyer.files.length > 0">
                <b-table striped hover :items="lawyer.files" :fields="['name', 'actions']">
                  <template slot="info" slot-scope="data">
                    <pre>
                      {{ data.item.response.data.id  }}
                    </pre>
                  </template>

                  <template slot="name" slot-scope="data">
                    <b-container fluid class="p-4">
                      <b-row>
                        <b-col>
                          {{ data.item.name }}
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <b-img thumbnail fluid :src="data.item.url" :alt="data.item.name" />
                        </b-col>
                      </b-row>
                    </b-container>
                  </template>

                  <template slot="progress" slot-scope="data">
                    <img v-if="data.item.progress != 100" src="@/assets/img/loader.gif" width="32">
                    <font-awesome-icon v-else icon="check" />
                  </template>

                  <template slot="actions" slot-scope="data">
                    <a @click.prevent="deleteBookFile(data.index)">
                      <font-awesome-icon icon="trash" size="lg" class="mr-2 text-danger"/>
                    </a>
                  </template>
                </b-table>
              </template>

              <div class="form-buttons">
                <button type="submit" class="btn btn-link" @click="$router.go(-1)">{{ $t('message.cancel') }} </button>
                <button type="submit" class="btn btn-success" @click="proceed">{{ $t('message.proceed') }} </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import {LAWYER_GET_NEW_ID, LAWYER_SAVE, LAWYER_REQUEST_BY_ID, LAWYERS_UPLOAD_FILE} from '@/store/actions/lawyers';

  import Multiselect from 'vue-multiselect';
  import FileUpload from 'vue-upload-component';

  import firebase from 'firebase/app';

  export default {
    name: "CreateLawyer",

    components: {
      Multiselect,
      FileUpload
    },

    data() {
      return {
        editor: ClassicEditor,
        editorConfig: {
          // The configuration of the editor.
        },

        lawyer: {
          name: '',
          url: '',
          url_label: '',
          email: '',
          email_contact: '',
          phone: '',
          web: '',
          address: '',
          default: false,
          photo: null,
        },

        uploadedFiles: [],
        newRecord: false,
      }
    },

    computed: {
      rerender() {
        return this.refresh
      },

      categoriesOptions() {
        return this.categories.map(el => { return {id: el.id, name: el.name} });
      },
    },

    mounted() {
      if (this.$route.params.id == undefined) {
        this.$store.dispatch(LAWYER_GET_NEW_ID).then(newId => {
          this.lawyer.id = newId;
          this.newRecord = true;
        })
      } else {
        this.getRow(this.$route.params.id);
      }
    },

    methods: {
      proceed() {
        this.$validator.validateAll().then(result => {
          if (!result) {
            this.$swal({
              title: 'Error!',
              text: this.$t("message.Lawyer.errors.fillRequiredFields"),
              type: 'error',
              confirmButtonText: 'OK'
            });

            this.showValidateErrors = true;
          } else {
            return this.saveLawyer();
          }
        });
      },

      async saveLawyer() {
        await this.$store.dispatch(LAWYER_SAVE, this.lawyer)
          .then((response) => {
            let message = this.$t("message.successfullyUpdated");

            if (this.newRecord) {
              message = this.$t("message.successfullyAdded");
            }

            this.$swal({
              title: this.$t("message.success"),
              text: message,
              type: 'success',
              confirmButtonText: 'OK'
            });

            this.$router.push({ name: 'LawyerList', params: { id: this.lawyer.id } })
          })
          .catch(error => {
            console.log(`error ${error}`)
          })
      },

      async getRow(id) {
        if (id != undefined) {
          this.$store.dispatch(LAWYER_REQUEST_BY_ID, id).then(row => {
            this.lawyer = row;
          }).catch(err => {
            console.log(err)
          })
        }
      },

      async upload(e) {
        var storageRef = firebase.storage().ref()

        this.uploadedFiles.forEach(elem => {
          let file = this.$refs.upload.get(elem.id).file
          this.$store.dispatch(LAWYERS_UPLOAD_FILE, {reviewerId: this.lawyer.id, file:file}).then(file => {
            elem.previewUrl = file.url
            elem.progress = 100
            this.lawyer.photo = file
          })
        })
      },
    },
  }
</script>


<style scoped>
.dragActive{
  background: white;
}

.dropzone {
  background: #e6e6e6;
  text-align: center;
  padding: 30px;
  border: 2px dashed;

  div {
    padding: 20px;
  }
}

.col-form-label {
  text-align: left;
}

.file-uploads {
  overflow: hidden;
  position: relative;
  text-align: center;
  display: inline-block;
}
.file-uploads.file-uploads-html4{
    input[type="file"] {
    opacity: 0;
    font-size: 20em;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;
    width: 100%;
    height: 100%;
  }
}

.file-uploads.file-uploads-html5{
  input[type="file"] {
    overflow: hidden;
    position: fixed;
    width: 1px;
    height: 1px;
    z-index: -1;
    opacity: 0;
  }
}

.img-thumbnail {
  max-width: 300px;
}
</style>
